export const HISTORY_TRENDS_FEATURE = 'history_trends'
export const MOSQUITO_SPECIES_RECOGNITION_FEATURE =
    'mosquito_species_recognition'
export const BASIC_DEVICE_PACKAGE_KEY = 'foundation'
export const BASIC_DEVICE_BOX_COLOR = '#000000'

export interface HistoryCapabilitySnapshot {
    package_key_at_upload?: string | null
    feature_keys_at_upload?: string[] | null
}

const hasFeature = (
    featureKeys: string[] | undefined,
    featureKey: string
): boolean => Boolean(featureKeys?.includes(featureKey))

export const supportsHistoryTrends = (
    featureKeys: string[] | undefined
): boolean => hasFeature(featureKeys, HISTORY_TRENDS_FEATURE)

export const supportsMosquitoSpeciesRecognition = (
    featureKeys: string[] | undefined
): boolean => hasFeature(featureKeys, MOSQUITO_SPECIES_RECOGNITION_FEATURE)

const normalizePackageKey = (value: string | null | undefined): string =>
    typeof value === 'string' ? value.trim().toLowerCase() : ''

export const shouldUseBasicBoxOnlyHistoryImage = (
    snapshot: HistoryCapabilitySnapshot
): boolean => {
    const featureKeys = Array.isArray(snapshot.feature_keys_at_upload)
        ? snapshot.feature_keys_at_upload
        : undefined

    return (
        normalizePackageKey(snapshot.package_key_at_upload) ===
            BASIC_DEVICE_PACKAGE_KEY &&
        !supportsMosquitoSpeciesRecognition(featureKeys)
    )
}
